import anime from "animejs";




(function($) {
  var header = $(".header");

  // $(".backplate").click(function() {
  //   $(".menu-tendina").removeClass("menu-tendina--active");
  //   $(".o-popup").removeClass("o-popup--open");
  //   $(".hamburger").removeClass("is-active");
  //   $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
  //   $(".btn-nav").removeClass("btn-nav--active");
  //   $(this).removeClass("backplate--open");

  //   $(".lista-orari").removeClass("lista-orari--active");
  //   $(".menu-tendina").removeClass("menu-tendina--orari");
  // });


  $(".header-mobile__trigger").click(function() {
    $(".menu-tendina").toggleClass("menu-tendina--active");
    // $(".backplate").toggleClass("backplate--open");
    $(".hamburger").toggleClass("is-active");

    // $(".lista-orari").removeClass("lista-orari--active");
    // $(".menu-tendina").removeClass("menu-tendina--orari");
  });



  // Header follow
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    // if (scroll >= $(window).height()) {
    //   header.addClass("active-scroll");
    // } else {
    //   header.removeClass("active-scroll");
    // }

    if (scroll >= 50) {
      header.addClass("header-v1--scroll");
    } else {
      header.removeClass("header-v1--scroll");
    }
  });

})(jQuery);



